import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getDatabase, ref as dbRef, get as dbGet, set as dbSet } from 'firebase/database'
import { getApp } from 'firebase/app'
import { handleErrors } from '../utils/errorHandler'

const DEFAULT_LARGE_GROUP_CUTOFF = 50

export const useSystemParamsStore = defineStore('SystemParamsStore', () => {
  const largeGroupCutoff = ref(DEFAULT_LARGE_GROUP_CUTOFF)
  const isLoaded = ref(false)

  async function loadLargeGroupCutoff() {
    try {
      const db = getDatabase(getApp())
      const snapshot = await dbGet(dbRef(db, 'SYSTEM_PARAMS/LARGE_GROUP_CUTOFF'))
      if (snapshot.exists()) {
        const val = snapshot.val()
        if (typeof val === 'number' && val > 0) {
          largeGroupCutoff.value = val
        }
      }
      isLoaded.value = true
    } catch (error) {
      handleErrors('SystemParamsStore - Loading LARGE_GROUP_CUTOFF', error)
      isLoaded.value = true
    }
  }

  /**
   * Build dynamic calendar/planning tool title labels based on the current cutoff.
   * @returns {Map<number, string>} Map of groupInsuranceTypeId → label
   */
  function getGroupTitleLabels() {
    const cutoff = largeGroupCutoff.value
    const smallMax = cutoff - 1
    return new Map([
      [0, `For large groups, ${cutoff}+ employees, fully insured`],
      [1, `For self-insured small groups, including level-funded (1-${smallMax} employees)`],
      [2, `For self-insured large groups, ${cutoff}+ employees, including level-funded`],
      [3, `For small groups, 1-${smallMax} employees, fully insured`],
    ])
  }

  async function saveLargeGroupCutoff(value) {
    const db = getDatabase(getApp())
    await dbSet(dbRef(db, 'SYSTEM_PARAMS/LARGE_GROUP_CUTOFF'), value)
    largeGroupCutoff.value = value
  }

  return {
    largeGroupCutoff,
    isLoaded,
    loadLargeGroupCutoff,
    saveLargeGroupCutoff,
    getGroupTitleLabels,
  }
})
